import { IGeo } from '@cian/chats-api';
import * as React from 'react';

export const useLocationId = (geo?: IGeo) => {
  const locationId = React.useMemo(() => {
    if (!geo) {
      return undefined;
    }

    return (geo.address.length > 0 && geo.address[0].id) || undefined;
  }, [geo]);

  return locationId;
};
